import { ImagesConfig } from 'types/commonInterfaces';

export const createImage = (src: string, srcSet = ''): Promise<boolean> => {
    return new Promise((resolve) => {
        if (window) {
            resolve(false);

            return;
        }

        const image = new Image();

        image.onload = image.onerror = () => {
            resolve(Boolean(image.height));
        };

        image.src = src;
        image.srcset = srcSet;
    });
};

const getSrcSet = (config: ImagesConfig, mediaType: string): string | undefined => {
    const srcSet = config.find(({ media, type }) => type === mediaType && window.matchMedia(media).matches)?.srcSet;

    if (srcSet) {
        return srcSet;
    }
};

export const preloadImages = async (config: ImagesConfig) => {
    if (!window) {
        return;
    }

    let srcSet;

    try {
        srcSet = getSrcSet(config, 'image/webp');
    } catch (error) {
        console.error(error);

        return;
    }

    if (!srcSet) {
        return;
    }

    createImage('', srcSet);
};
